import TabItemLink from "./tab-item-link";
import './index.less'
import { CSSProperties, ReactNode, useCallback, useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import { CommonTabbarContext } from "@/App";
import localStore, { TABBAR_CLOSABLE } from "@/global/store/local-store";

export interface TabRoute {
    title: string
    themeColor?: string
    url: string
    closable?: boolean
    popConfirm?: boolean
    params?: any
    components?: ReactNode
    closeCallbackFn?: (tab: TabRoute) => Promise<any>
}

export interface CommonTabbarState {
    routes: TabRoute[],
    themeColor: string,
    setRoutesOverwrite: (value: TabRoute[]) => void,
    pushRoute: (value: TabRoute) => void,
    clearClosableRoute: () => void,
    changeTheme: (value: string) => void,
    navigate: (url: string) => void,
    registerNavigate: (fn: (url: string) => void) => void,
}

export const useCommonTabbarService = () => {
    const [routes, setRoutes] = useState<TabRoute[]>([]);
    const [themeColor, setThemeColor] = useState<string>(null);
    const [navigate, setNavigate] = useState<(url: string) => void>();

    const setRoutesOverwrite = useCallback((value: TabRoute[]) => {
        setRoutes(prev => {
            localStore.set(TABBAR_CLOSABLE, value.filter(item => item.closable));
            return [...value];
        })
    }, [])

    const changeTheme = useCallback((value: string) => {
        setThemeColor(value);

    }, [])

    const pushRoute = (value: TabRoute) => {
        // 往现有的tabs里加一个
        setRoutes(prev => {
            let idx = prev.findIndex(item => item.url === value.url);
            if (idx > -1) {
                let route = prev[idx];
                route.themeColor = value.themeColor;
                route.title = value.title;
                route.closable = value.closable;
                route.params = value.params;
                let res = [...prev];
                localStore.set(TABBAR_CLOSABLE, res.filter(item => item.closable));
                return res;
            }
            let res = [
                ...prev,
                value,
            ]
            localStore.set(TABBAR_CLOSABLE, res.filter(item => item.closable));
            return res;
        })
    }

    const clearClosableRoute = () => {
        localStore.set(TABBAR_CLOSABLE, []);
        setRoutes(prev => {
            let cur = prev?.filter(item => !item.closable);
            return [...cur];
        })
    }

    const registerNavigate = (fn: (url: string) => void) => {
        setNavigate(() => fn);
    }

    return {
        routes,
        themeColor,
        setRoutesOverwrite,
        pushRoute,
        clearClosableRoute,
        changeTheme,
        navigate,
        registerNavigate,
    } as CommonTabbarState
}


interface Iprops {
    context?: React.Context<CommonTabbarState>
    maxWidth?: string | number
    name?: string
    tabInpage?: number
    style?: CSSProperties
    className?: string
}

function CommonTabbar(props: Iprops) {
    const { projectId } = useParams();
    const navigate = useNavigate();

    const context = useContext<CommonTabbarState>(props.context || CommonTabbarContext);
    let [scrollActive, setScrollActive] = useState<boolean>(false);

    const onClose = (route, active) => {
        let idx = context.routes.findIndex(item => item === route);
        let res = context.routes.filter(item => item != route) || [];
        context.setRoutesOverwrite(res);

        //同步删除预览的文件的缓存
        let closableTabbar: TabRoute[] = localStore.get(TABBAR_CLOSABLE)
        closableTabbar = closableTabbar.filter(item => item.url !== route.url) || [];
        localStore.set(TABBAR_CLOSABLE, closableTabbar)


        if (!active) return;
        if (res.length <= 0) return;
        if (idx >= res.length) idx = res.length - 1;
        if (idx < 0) idx = 0;


        if (!!context.navigate) {
            context.navigate(res[idx].url);
        } else {
            navigate(-1);
        }
    }

    const scrollHorizontally = useCallback((e) => {
        e.stopPropagation();
        const ele = document.getElementById(props.name);

        let delta = e.deltaX || e.deltaY;
        // console.log(delta)
        ele.scrollLeft += delta * 2
    }, [])

    return (
        <div className={classNames({
            "common-tabbar-container": true,
        }, props.className)} style={{
            maxWidth: `${props.maxWidth}`,
            ...props.style || null,
        }} id={props.name} onMouseEnter={(e) => document.addEventListener("wheel", scrollHorizontally)} onMouseLeave={(e) => { document.removeEventListener('wheel', scrollHorizontally) }}>
            <div className="scrollable" >
                {context.routes?.map(route => (
                    <TabItemLink key={route.url} tabRoute={route} theme={context.themeColor} onClose={onClose} tabInPage={props.tabInpage} />
                ))}
            </div>

        </div>
    )
}

CommonTabbar.defaultProps = {
    name: "tab-scrollable",
    tabInpage: 0,
}

export default CommonTabbar;